import { numValidation } from "helpers/validations"
import { t } from "i18next"
import { isValidPhoneNumber } from "react-phone-number-input"
import * as yup from "yup"

const getClientLeadValidationSchema = () =>
  yup.object().shape({
    mobileNumber: yup
      .string()
      .test("required", t("Phone number is required"), value => {
        return !value ? false : true
      })
      .test("valid", t("Invalid Phone Number"), value => {
        return isValidPhoneNumber(value ? value : "-")
      }),
    searchAffiliate: yup.object().required(t("This Field needs to be selected")).nullable(),
    searchId: numValidation(t("Search ID is required"), 15, "naturalNumbers"),
  })

export default getClientLeadValidationSchema
